const baseUrl = process.env.BASE_URL
export default {
    avatarArr: [
        baseUrl + 'avatars/avatar01.jfif',
        baseUrl + 'avatars/avatar02.jfif',
        baseUrl + 'avatars/avatar03.jfif',
        baseUrl + 'avatars/avatar04.jfif',
        baseUrl + 'avatars/avatar05.webp',
        baseUrl + 'avatars/avatar06.webp',
        baseUrl + 'avatars/avatar07.jfif',
        baseUrl + 'avatars/avatar08.webp',
        baseUrl + 'avatars/avatar09.jpg',
        baseUrl + 'avatars/avatar10.jfif',
        baseUrl + 'avatars/avatar11.png',
        baseUrl + 'avatars/avatar12.png',
        baseUrl + 'avatars/avatar13.png',
        baseUrl + 'avatars/avatar14.png',
        baseUrl + 'avatars/avatar15.png',
        baseUrl + 'avatars/avatar16.png',
        baseUrl + 'avatars/avatar17.jfif',
        baseUrl + 'avatars/avatar18.png',
        baseUrl + 'avatars/avatar19.png',
        baseUrl + 'avatars/avatar20.png',
    ]
}